<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="65%"
      :title="title"
      append-to-body
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-loading="dialogLoading"
    >
    <div style="max-height:calc(100vh - 350px);overflow: scroll;">
      <avue-form
        :option="option"
        v-model="form"
        v-if="dialogVisible"
        ref="form"
      >
        <template slot="projectId">
          <el-select
            v-model="form.projectId"
            :disabled="disabled"
            @change="projectIdChange"
          >
            <el-option
              v-for="item in projectIdList"
              :key="item"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="originWarehouseId">
          <el-select v-model="form.originWarehouseId" :disabled="disabled">
            <el-option
              v-for="item in originWarehouseList"
              :key="item"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="destWarehouseId">
          <el-select
            v-model="form.destWarehouseId"
            :disabled="disabled"
            @change="getOriginWarehouse"
          >
            <el-option
              v-for="item in destWarehouseList"
              :key="item"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="requisitionDept">
          <el-select v-model="form.requisitionDept" :disabled="disabled">
            <el-option
              v-for="item in deptList"
              :key="item"
              :value="item.id"
              :label="item.fullName"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="menuForm">
          <!-- <el-button
                                                v-if="editable"
                                                @click="applyFormAction(1)"
                                                type="primary">
                                                保存
                                        </el-button> -->
          <el-button
            v-if="editable"
            :loading="loading"
            @click="applyFormAction(2)"
            type="primary"
          >
            提交
          </el-button>
          <el-button
            v-if="!editable && auditBtn"
            @click="openAduitDialog"
            type="primary"
          >
            审核
          </el-button>
          <el-button v-if="!editable && printBtn" @click="print">
            打印
          </el-button>
          <el-button :loading="loading" @click="applyFormAction(3)">
            取消
          </el-button>
        </template>
        <template slot="dataList">
          <div>
            <ConsumableSelector
              :showSum="true"
              ref="cs"
              :columns="csColumns"
              :numberMode="numberMode"
              :numberKey="csNumKey"
              :priceKey="csPriceKey"
              :data.sync="csData"
              :projectId="this.form.projectId"
              @loadData="loadData"
              :priceMode="priceMode"
              @loadPrice="loadPrice"
              :editable="editable"
              @afterAdd="csDataAfterAdd"
              :scene="'out'"
              :priceValidate="false"
            />
          </div>
        </template>
      </avue-form>
      </div>
      <template slot="footer">

      
      <div style="display: flex; justify-content: center; margin-top: 30px">
        <el-button v-if="editable" type="primary" @click="applyFormAction(1)">
          保存
        </el-button>
        <el-button
          v-if="editable"
          :loading="loading"
          @click="applyFormAction(2)"
          type="primary"
        >
          提交
        </el-button>
        <el-button
          v-if="!editable && auditBtn"
          @click="openAduitDialog"
          type="primary"
        >
          审核
        </el-button>
        <el-button v-if="!editable && printBtn" @click="print">
          打印
        </el-button>
        <el-button :loading="loading" @click="applyFormAction(3)">
          取消
        </el-button>
      </div>
    </template>
    </el-dialog>
    <el-dialog
      :visible.sync="aduitDialog"
      width="40%"
      title="审核"
      append-to-body
      :close-on-click-modal="false"
      v-loading="aduitloading"
    >
      <el-row>
        <el-col>
          <el-form ref="aduitform" :model="aduitform" label-width="80px">
            <el-form-item
              label="审核备注"
              required
              prop="remark"
              :rules="[
                { required: true, message: '请填写备注', trigger: 'blur' },
              ]"
            >
              <el-input
                placeholder="请输入备注信息"
                type="textarea"
                maxlength="300"
                show-word-limit
                rows="5"
                v-model="aduitform.remark"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div style="display: flex; justify-content: center">
        <el-button type="primary" @click="aduit(3)"> 通过 </el-button>
        <el-button @click="aduit(4)"> 驳回 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import formOption from "./from-option";
import ConsumableSelector from "@/components/consumable-selector/index";
import {
  getDetail,
  getDegetConsumableListByRequisitionIdtail,
  consumableList,
  applyFormDetail,
  saveFormDetail,
  consumableCalculate,
} from "@/api/warehouse-allot/warehouse-allot";
import {
  aduit,
  viewUpdateConsumableList,
  getWarehouseListApply, //获取仓库下拉列表
  getAllWarehouseListApply, //不带权限
  treeDeptsByIds, //当前登录人获取科室
} from "@/api/warehouseRequisition/warehouserequisition";
import { getDict, getBusinessNo } from "@/api/crmedical/warehouse/index.js";
import { mapGetters } from "vuex";
export default {
  components: {
    ConsumableSelector,
  },
  props: {},
  data() {
    return {
      title: "",
      dialogLoading: false,
      auditBtn: false,
      printBtn: false,
      numberMode: "input",
      priceMode: "normal",
      aduitform: {},
      aduitloading: false, //审核表单提交状态样式
      aduitDialog: false, //审核弹窗
      deptList: [],
      disabled: false,
      loading: false,
      option: formOption,
      dialogVisible: false,
      csData: [],
      csNumKey: "allotNum",
      csColumns: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "分类", prop: "typeName" },
        { label: "单位", prop: "measuringUnitName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "库存单价", prop: "price" },
        { label: "库存数量", prop: "stockNum" },
        {
          label: "调拨数量",
          prop: "allotNum",
          // maxCheck: true,
        },
        { label: "小计", prop: "rowSum" },

        {
          label: "剩余可数量领用",
          prop: "surplus",
          maxCheck: true,
          hide: true,
        },
      ],
      pageLoading: false,
      userlist: [],
      allwarehouseList: [], //不带权限
      destWarehouseList: [],
      baseWarehouseList:[],
      warehouseInboundTypeList: [],
      inboundStatusList: [],
      dicts: {},
      editable: "add",
      form: {
        projectId: "",
        warehouseId: "",
        destWarehouseId: "",
        originWarehouseId: "",
        type: "",
        inboundStatus: "",
        allotNo: "",
        linkNo: "",
        id: "",
      },
      addDialogVisible: false,
      data: [], //入库单列表
      csData: [],
      submitFlag: true,
      mode: "",
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    projectIdChange(val) {
      if (!this.form.projectId) {
        return;
      }
      this.form.originWarehouseId = "";
      this.form.destWarehouseId = "";
      this.csData = [];
      this.userlist = [];
      this.getWarehouseList();
    },

    // 根据当前登录人获取科室
    treeDeptsByIds() {
      treeDeptsByIds().then((res) => {
        this.deptList = res.data;
        if (this.title == "申请") {
          this.form.requisitionDept = this.deptList[0]
            ? this.deptList[0].id
            : "";
        }
      });
    },
    // 获评变动后回调
    csDataAfterAdd(data, all) {
      // this.viewUpdateConsumableList(all);
    },
    // 查询单价
    viewUpdateConsumableList(all) {
      let params = {
        warehouseId: this.form.originWarehouseId,
        inboundConsumableList: all || this.csData,
      };
      viewUpdateConsumableList(params).then((res) => {
        this.csData.forEach((ele, index) => {
          ele.price = res.data[index].stockPrice;
          ele.stockNum = res.data[index].stockNum;
        });
        this.$refs.cs.calcSums();
        // this.csData = res.data;
      });
    },
    // 打开审核弹窗
    openAduitDialog() {
      this.aduitDialog = true;
    },
    // 审核
    aduit(status) {
      this.aduitform.status = status;
      this.$refs.aduitform.validate((valid) => {
        if (valid) {
          aduit(this.aduitform).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.aduitform.remark = "";
            this.aduitDialog = false;
            this.dialogVisible = false;
            this.$emit("onLoad");
          });
        } else {
        }
      });
    },
    // 打印
    print() {
      this.$message({
        message: "该功能暂未开放",
        type: "warning",
      });
    },
    // 打开弹窗页面
    openDialog(data) {
      this.treeDeptsByIds();
      this.form = {
        warehouseId: "",
        projectId: "",
        id: "",
      };
      this.submitFlag = true;
      this.csData = [];
      let projeCtcolumn = this.findObject(this.option.column, "projectId");
      projeCtcolumn.dicData = data.dicData.projectIdDictDataList;
      this.projectIdList = data.dicData.projectIdDictDataList;

      data.dicData.userlist.forEach((item) => {
        item.label = item.label;
        item.value = item.value;
      });
      this.userlist = data.dicData.userlist;
      console.log("this.userlist====>", this.userlist);
      this.option.submitBtn = true;
      this.auditBtn = false;
      this.disabled = false;
      if (data.type == "add") {
        this.title = "申请";
        this.numberMode = "input";
        this.editable = true;
        this.priceMode = "normal";
        this.mode = "no-first";
        this.form.projectId = data.dicData.projectIdDictDataList[0].id
          ? data.dicData.projectIdDictDataList[0].id
          : "";
        this.form.id = "";
        this.form.requisitionTime = new Date();
        getBusinessNo({ businessType: 6 }).then((res) => {
          this.form.allotNo = res.data;
        });

        this.getWarehouseList();
        this.option.disabled = false;
        this.dialogVisible = true;
      }
      if (data.type == "view") {
        this.option.submitBtn = false;
        this.title = "查看";
        this.numberMode = "mormal";
        this.editable = false;
        this.printBtn = false;
        this.mode = "first";
        this.disabled = true;
        this.aduitform.id = data.data.id;
        this.getDetail(data.data.id, (detail) => {
          console.log("detail 1234567==>", detail);
          this.form = detail;
          this.form.projectId = detail.projectId;
          this.form.requisitionDept = detail.requisitionDept;
          this.form.remark = detail.remark;
          this.form.allotNo = detail.allotNo;
          this.getWarehouseList();
          if (detail.requisitionStatus == 2 && data.auditBtn) {
            this.auditBtn = true;
          }
          if (
            detail.requisitionStatus == 3 ||
            detail.requisitionStatus == 4 ||
            detail.requisitionStatus == 5 ||
            detail.requisitionStatus == 6 ||
            detail.requisitionStatus == 7 ||
            detail.requisitionStatus == 8
          ) {
            this.printBtn = true;
          }
          console.log("detail.consumableList========>", detail.consumableList);
          this.csData = detail.consumableList;
          this.dialogVisible = true;
        });

        // this.getDegetConsumableListByRequisitionIdtail(data.data.id);
        this.option.disabled = true;
      }
      if (data.type == "edit") {
        this.title = "编辑";
        this.numberMode = "input";
        this.editable = true;
        this.mode = "first";
        this.disabled = true;
        this.aduitform.id = data.data.id;
        this.getDetail(data.data.id, (detail) => {
          this.form = detail;
          this.form.projectId = detail.projectId;
          this.form.requisitionDept = detail.requisitionDept;
          this.form.remark = detail.remark;
          this.form.requisitionNo = detail.requisitionNo;
          console.log("detail.consumableList========>", detail.consumableList);
          this.csData = detail.consumableList;
          this.dialogVisible = true;
        });
        this.option.disabled = false;
      }
    },
    getDetail(id, callback) {
      getDetail({ id: id }).then((res) => {
        callback(res.data);
      });
    },
    formError(done) {
      done();
    },
    // 保存 提交
    async applyFormAction(type, form, done, loading) {
      console.log(type, form, done);
      if (done) {
        done();
      }
      if (type == 3) {
        this.$confirm('确认关闭?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
        })
        .then(()=> {
                this.dialogVisible = false;
                this.$emit("onLoad");
        })
        return;
      }

      let validateResult = this.$refs.cs.validate();
      if (!validateResult) {
        console.log(validateResult);
        return;
      }

      let flag = true;
      this.csData.forEach((ele) => {
        let a = Number(ele.allotNum);
        if (ele.allotNum == "" || Number(ele.allotNum) < 1) {
          flag = false;
        }
      });

      if (this.form.destWarehouseId && this.form.originWarehouseId) {
        if (this.form.destWarehouseId === this.form.originWarehouseId) {
          this.$message({
            message: "调入仓库和调出仓库不能相同！",
            type: "warning",
          });
          return;
        }
      }

      if (!flag) {
        this.$message({
          message: "请输入正确的调拨数量",
          type: "warning",
        });
        return;
      }
      if (this.csData.length < 1 && type != 3) {
        if (type == 1) {
          this.$message({
            message: "请选择申请物品后再保存",
            type: "warning",
          });
        } else {
          this.$message({
            message: "请选择申请物品后再提交",
            type: "warning",
          });
        }

        return;
      }
      // this.$refs.form.validate((valid) => {});

      let valid_ = true;
      await this.$refs.form.validate((valid, done, msg) => {
        valid_ = valid;
        done();
      });
      if (!valid_) {
        return;
      }
      if (valid_) {
        // this.form.requisitionStatus = type;

        // this.form.requisitionTime = this.dayjs(this.form.requisitionTime).format('YYYY-MM-DD HH:mm:ss')
        if (!this.submitFlag) {
          return;
        }
        this.submitFlag = false;
        this.loading = true;
        this.form.consumableList = [];
        this.csData.forEach((ele) => {
          let temObj = {
            consumableId: ele.consumableId,
            allotNum: ele.allotNum,
            price: ele.price,
          };
          this.form.consumableList.push(temObj);
        });
        if (type == 2) {
          applyFormDetail(this.form)
            .then((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.form.id = res.data.id;
              this.submitFlag = true;
              this.loading = false;
              // if(type==1){
              //         this.$message({
              //                 message: '保存成功',
              //                 type: 'success'
              //         });
              //         this.$refs.crud.toggleSelection();
              //         this.option.disabled = false;
              // }else{
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.$emit("onLoad");
              // }
            })
            .catch((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.submitFlag = true;
              this.loading = false;
            });
        }

        if (type == 1) {
          saveFormDetail(this.form)
            .then((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.form.id = res.data.id;
              this.submitFlag = true;
              this.loading = false;
              // if(type==1){
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$refs.crud.toggleSelection();
              this.option.disabled = false;
              // }else{
              //         this.$message({
              //                 message: '提交成功',
              //                 type: 'success'
              //         });
              //         this.dialogVisible = false;
              //         this.$emit('onLoad');
              // }
            })
            .catch((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.submitFlag = true;
              this.loading = false;
            });
        }
      } else {
        return false;
      }
      if (done) {
        done();
      }
    },
    // 根据id获取材料清单
    getDegetConsumableListByRequisitionIdtail(id) {
      getDegetConsumableListByRequisitionIdtail({ requisitionId: id }).then(
        (res) => {
          res.data.forEach((ele) => {
            ele.rowSum = ele.inboundNum * ele.price;
            ele.rowSum = ele.rowSum.toFixed(2);
          });
          this.csData = res.data;
          this.dialogVisible = true;
          setTimeout(() => {
            console.log("this.$refs.form========>", this.$refs.form);
          });
        }
      );
    },
    // 获取调出仓库列表
    getOriginWarehouse() {
      let temArr = [];
      this.baseWarehouseList.forEach((ele) => {
        if (ele.id != this.form.destWarehouseId) {
          temArr.push(ele);
        }
      });
      this.originWarehouseList = temArr;
      if (this.title == "申请") {
        this.form.originWarehouseId = this.originWarehouseList[0]
          ? this.originWarehouseList[0].id
          : "";
      }
    },
    // 获取仓库列表 科室列表 不带权限
    //     getAllWarehouseListApply() {
    //       if (this.mode == "first") {
    //       } else {
    //         this.form.warehouseId = "";
    //       }
    //       this.allwarehouseList = [];
    //       getAllWarehouseListApply({ projectId: this.form.projectId }).then(
    //         (res) => {
    //           this.allwarehouseList = res.data;
    //           this.getOriginWarehouse();
    //         }
    //       );
    //     },
    //     // 获取仓库列表 科室列表 带权限
    //     getWarehouseList() {
    //       if (this.mode == "first") {
    //       } else {
    //         this.form.warehouseId = "";
    //       }
    //       getWarehouseListApply({ projectId: this.form.projectId }).then((res) => {
    //         this.getAllWarehouseListApply();
    //         this.warehouseList = res.data;
    //         this.form.destWarehouseId = this.warehouseList[0]
    //           ? this.warehouseList[0].id
    //           : "";

    //         if (this.mode != "first") {
    //           this.form.warehouseId = this.warehouseList[0]
    //             ? this.warehouseList[0].id
    //             : "";
    //         }
    //       });
    //     },

    getWarehouseList() {
      this.dialogLoading = true;
      getWarehouseListApply({ projectId: this.form.projectId })
        .then(({ data }) => {
          this.destWarehouseList = data;
          
          if (this.title == "申请") {
            this.form.destWarehouseId = this.destWarehouseList[0]
              ? this.destWarehouseList[0].id
              : "";
          }
          getAllWarehouseListApply({ projectId: this.form.projectId })
            .then(({ data }) => {
              this.dialogLoading = false;
              this.originWarehouseList = data;
              this.baseWarehouseList = JSON.parse(JSON.stringify(data));
              this.getOriginWarehouse();
            })
            .catch((err) => {
              this.dialogLoading = false;
            });
        })
        .catch((err) => {
          this.dialogLoading = false;
        });
    },

    loadData(query, resolve) {
      query.name = query.text;
      const params = {
        ...query,
        projectId: this.form.projectId,
        warehouseId: this.form.originWarehouseId,
      };
      // const params = { ...query, projectId: this.form.projectId};
      const columns = [
        { label: "分类", prop: "typeName" },
        { label: "编号", prop: "code" },
        { label: "名称", prop: "name" },
        { label: "计量单位", prop: "measuringUnitName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
      ];
      consumableList(params).then((res) => {
        res.data.records.forEach((element) => {
          element.id = "";
          element.price = element.stockPrice;
        });
        resolve(res.data, columns);
      });
    },
    loadPrice(query, resolve) {
      const params = {
        ...query,
        warehouseId: this.form.originWarehouseId,
      };
      consumableCalculate(params).then((res) => {
        console.log("res consumableCalculate==>", res);
        resolve(res.data);
      });
    },
    async fetchData() {
      this.pageLoading = true;
      try {
        //type && status
        const dicts = await Promise.all([
          getDict({ code: "warehouse_inbound_type" }),
          getDict({ code: "inbound_status" }),
        ]);
        this.warehouseInboundTypeList = dicts[0].data;
        this.form.type = this.warehouseInboundTypeList[0].dictKey;
        this.inboundStatusList = dicts[1].data;
        this.form.inboundStatus = this.inboundStatusList[0].dictKey;
        //load list
        // this.loadList();
      } catch (err) {}
      this.pageLoading = false;
    },
  },
};
</script>
